import { render, staticRenderFns } from "./ContentLabelCascader.vue?vue&type=template&id=d98bdb88&scoped=true"
import script from "./ContentLabelCascader.vue?vue&type=script&lang=js"
export * from "./ContentLabelCascader.vue?vue&type=script&lang=js"
import style0 from "./ContentLabelCascader.vue?vue&type=style&index=0&id=d98bdb88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98bdb88",
  null
  
)

export default component.exports